var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',_vm._b({attrs:{"href":_vm.link},on:{"click":function($event){$event.preventDefault();return _vm.push.apply(null, arguments)}}},'a',_vm.$attrs,false),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }